import Vue from 'vue'
import Vuex from 'vuex'
import mapConfig from './../../static/config/mapConfig.js';

import axios from 'axios';
import Qs from 'qs';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
		app:"",//组件切换
		user:{},
		staticShow:false,
    },
});

export default store; 


// WEBPACK FOOTER //
// ./src/vuex/store.js